import { IdName } from '~/api/_utils/common';

import { ArticleT } from './article';
import { OrgT } from './org';
import { SocialIssueProblemT } from './socialIssueProblem';

export type SocialIssueCategoryT = {
  id: number;
  name: string;
  color: string;
};

export const OTHER_SOCIAL_ISSUE_CATEGORY = {
  id: 0,
  name: 'その他',
  color: '#8A8A8A',
};

export type SocialIssueT = {
  id: number;
  type: 'GeneralSocialIssue' | 'PrefectureSocialIssue' | 'CitySocialIssue';
  name: string;
  display_name: string;
  image: string;
  color: string;
  font_color: string;
  title: string;
  description: string;
  overview: string;
  cover: string;
  sdgs: number[];
  tags: IdName[];
  about: string;
  about_image: string;
  about_image_notice?: string;
  about_title: string;
  about_text: string;
  why_title: string;
  why_image: string;
  why_image_notice: string;
  why_text: string;
  stakeholder_title: string;
  stakeholder_text: string;
  problem_title: string;
  problem_text: string;
  solution_title: string;
  solution_text: string;
  articles: ArticleT[];
  good_image: string;
  good_text: string;
  bad_image: string;
  social_issue_problems: SocialIssueProblemT[];
  others: string[];
  orgs: OrgT[];
  organizations?: OrgT[];
  population: string;
  area: string;
  density: string;
  link: string;
  link_title: string;
  problems: string;
  sdgs_score?: number[];
  social_issue_category?: SocialIssueCategoryT;
};
